export enum Feature {
  INCOME_VERIFICATION = 'income_verification',
  PAYROLL_LINKING = 'payroll_linking',
  BANK_LINKING = 'bank_linking',
  IDENTITY_VERIFICATION = 'identity_verification',
  IDENTITY_VERIFICATION_ONLY_WEB_PORTAL = 'identity_verification_only_web_portal',
  ASSET_VERIFICATION = 'asset_verification',
  RENTAL_HISTORY = 'rental_history',
  TAX_LINKING = 'tax_linking',
  REFERENCE_COMPLETED_NOTIFICATION = 'reference_completed_notification',
  CPN_FRAUD_CHECK = 'cpn_fraud_check',
  OFFER_LETTER_VERIFICATION = 'offer_letter_verification',
  AUTO_EMPLOYMENT_VERIFICATION = 'auto_employment_verification',
  AUTO_EMPLOYMENT_VERIFICATION_ALWAYS_ON = 'auto_employment_verification_always_on',
  VERIFY_MY_WAY = 'verify_my_way',
  VERIFY_MY_WAY_BASIC = 'verify_my_way_basic',
  ENHANCED_FINANCIAL = 'enhanced_financial',
  ON_BEHALF_OF = 'on_behalf_of',
  ON_BEHALF_OF_SIGNATURE_REQUIRED = 'on_behalf_of_signature_required',
  DISABLE_PROPERTY_LINKS = 'disable_property_links',
  APPLICATION_TRACKING = 'application_tracking'
}

export enum FeatureState {
  DISABLED = 'disabled',
  ENABLED = 'enabled'
}
